module.exports = __webpack_public_path__ + "img/tableau-de-bord-24px-outline.89460011.svg";